import { render, staticRenderFns } from "./book-list.vue?vue&type=template&id=01748c35&scoped=true"
import script from "./book-list.vue?vue&type=script&lang=js"
export * from "./book-list.vue?vue&type=script&lang=js"
import style0 from "./book-list.vue?vue&type=style&index=0&id=01748c35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01748c35",
  null
  
)

export default component.exports